// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"23a0a2f8","488":"3b1b8a88","977":"a1c5cfcc"}[chunkId] + ".chunk.js";
};